// extracted by mini-css-extract-plugin
module.exports = {"infoBlock":"style_info-block__Dm4om","subtitle":"style_subtitle__IczbO","points":"style_points__W3FpZ","point":"style_point___owvH"};